export enum ChatTicketType {
  clinical = "clinical",
  techSupport = "techSupport",
}
